// extracted by mini-css-extract-plugin
module.exports = {"root":"GeySM","label":"_2g_QW","value":"_3TIJT"};